import { render, staticRenderFns } from "./accordion-section.vue?vue&type=template&id=1b83a9f9"
import script from "./accordion-section.vue?vue&type=script&lang=js"
export * from "./accordion-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/elismargon/Developer/royalty/Mod.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b83a9f9')) {
      api.createRecord('1b83a9f9', component.options)
    } else {
      api.reload('1b83a9f9', component.options)
    }
    module.hot.accept("./accordion-section.vue?vue&type=template&id=1b83a9f9", function () {
      api.rerender('1b83a9f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/js/components/accordion-section.vue"
export default component.exports